import { Link } from "react-router-dom";
import { Pinned } from "../../../assets/icons";

interface IPinnedProjects {
    handlePinned: any;
    handleNavigate?: any;
}

export const pinnedProjects = ({ handlePinned, handleNavigate }: IPinnedProjects) => [
    {
        title: "",
        dataIndex: "icons",
        key: "icons",
        sortable: false,
        width: "7%",
        render: (_: string, record: { isPinned: boolean }) => (
            <div className="flex justify-center py-[3px]">
                <Pinned
                    className="cursor-pointer"
                    size={18}
                    onClick={() => handlePinned(record)}
                />
            </div>
        ),
    },
    {
        title: "Project",
        dataIndex: "projectName",
        key: "projectName",
        sortable: false,
        width: "53%",
        render: (_: string, record: { projectName: string; projectID: string }) => (
            <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                <label className="text-[14px] text-primary-400 cursor-pointer truncate w-full hover:underline focus:underline active:underline">
                    {record?.projectName}
                </label>
            </Link>
        ),
    },
    {
        title: "Location",
        dataIndex: "location",
        key: "location",
        sortable: false,
        width: "40%",
        render: (_: string, record: { country: string; state: string,county: string }) => (
            <div className="text-neutral-25 text-[14px]">
                {record.country}
                {record.state ? `, ${record.state}` : ""}
                {record.county ? `, ${record.county}` : ""}
            </div>
        ),
    },
];
